// Registry of generated layout components, keyed by the raw design layout name.
import AnonymousWebLayoutWvalbl from './AnonymousWebLayoutWvalbl.jsx';
import AnonymousWebLayout from './AnonymousWebLayout.jsx';
import BanquetEventKitsBatchReconciliationLayout from './BanquetEventKitsBatchReconciliationLayout.jsx';
import DefaultWebLayout1jru55b from './DefaultWebLayout1jru55b.jsx';
import DefaultWebLayout1rckt4r from './DefaultWebLayout1rckt4r.jsx';
import DefaultWebLayout7gr5z5 from './DefaultWebLayout7gr5z5.jsx';
import DefaultWebLayout from './DefaultWebLayout.jsx';
import GuestLoanersOverdueTrackerLayout from './GuestLoanersOverdueTrackerLayout.jsx';
import PropertyLocationRegistryLayout from './PropertyLocationRegistryLayout.jsx';

export const LAYOUTS = {
  '_anonymous-web-layout-wvalbl': AnonymousWebLayoutWvalbl,
  '_anonymous-web-layout': AnonymousWebLayout,
  '_banquet-event-kits-batch-reconciliation-layout': BanquetEventKitsBatchReconciliationLayout,
  '_default-web-layout-1jru55b': DefaultWebLayout1jru55b,
  '_default-web-layout-1rckt4r': DefaultWebLayout1rckt4r,
  '_default-web-layout-7gr5z5': DefaultWebLayout7gr5z5,
  '_default-web-layout': DefaultWebLayout,
  '_guest-loaners-overdue-tracker-layout': GuestLoanersOverdueTrackerLayout,
  '_property-location-registry-layout': PropertyLocationRegistryLayout,
};

export {
  AnonymousWebLayoutWvalbl,
  AnonymousWebLayout,
  BanquetEventKitsBatchReconciliationLayout,
  DefaultWebLayout1jru55b,
  DefaultWebLayout1rckt4r,
  DefaultWebLayout7gr5z5,
  DefaultWebLayout,
  GuestLoanersOverdueTrackerLayout,
  PropertyLocationRegistryLayout,
};
